export default "__VITE_ASSET__cc103b70__"